import { cn } from '@/lib/utils'
import { IconChevronDown } from '@/components/Icons'

export type FaqEntry = { question: string; answer: string }

export function FaqList({
  items,
  name,
  className,
}: {
  items: FaqEntry[]
  name: string
  className?: string
}) {
  return (
    <div className={cn('grid gap-3', className)}>
      {items.map((item, index) => (
        <details
          key={item.question}
          name={name}
          open={index === 0}
          className="faq-item group rounded-2xl border border-[var(--surface-border)] bg-[var(--surface-card)]/70 transition-[border-color,background-color] duration-300 open:border-[var(--color-brand-accent)]/30 open:bg-[var(--surface-card)] hover:border-[var(--surface-border-strong)]"
        >
          <summary className="flex cursor-pointer list-none items-center justify-between gap-6 rounded-2xl px-5 py-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-brand-accent-readable)] sm:px-6 sm:py-5">
            <h3 className="text-[15px] font-semibold leading-snug text-[var(--text-strong)] sm:text-base">
              {item.question}
            </h3>
            <span
              aria-hidden="true"
              className="flex size-8 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-[var(--surface-muted)] transition-[transform,color,border-color] duration-300 group-open:rotate-180 group-open:border-[var(--color-brand-accent)]/40 group-open:text-[var(--color-brand-accent-readable)]"
            >
              <IconChevronDown size={16} />
            </span>
          </summary>
          <p className="px-5 pb-5 text-sm leading-relaxed text-[var(--surface-muted)] sm:px-6 sm:text-[15px]">
            {item.answer}
          </p>
        </details>
      ))}
    </div>
  )
}
